module.exports = __webpack_public_path__ + "media/images/email/file-attached-1-d221b7ea275e57df01d1a1c2875dacb8.jpg";